import { Card } from "@/components/ui/card";
import { DollarSign, ArrowUpRight, ArrowDownRight, Wallet } from "lucide-react";

interface EarningsStatsProps {
  stats: {
    totalEarnings: number;
    pendingPayments: number;
    completedPayments: number;
    commissionsTotal: number;
  };
}

export const EarningsStats = ({ stats }: EarningsStatsProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">Total Earnings</p>
            <p className="text-2xl font-bold">${stats.totalEarnings.toFixed(2)}</p>
          </div>
          <DollarSign className="h-8 w-8 text-green-500" />
        </div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">Pending Payments</p>
            <p className="text-2xl font-bold">${stats.pendingPayments.toFixed(2)}</p>
          </div>
          <ArrowUpRight className="h-8 w-8 text-yellow-500" />
        </div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">Completed Payments</p>
            <p className="text-2xl font-bold">${stats.completedPayments.toFixed(2)}</p>
          </div>
          <ArrowDownRight className="h-8 w-8 text-blue-500" />
        </div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">Commissions Paid</p>
            <p className="text-2xl font-bold">${stats.commissionsTotal.toFixed(2)}</p>
          </div>
          <Wallet className="h-8 w-8 text-purple-500" />
        </div>
      </Card>
    </div>
  );
};